module.exports = require("@swa-ui/shopping/src/CompanySelection/CompanySelection.module.scss");